import React, { useState, useEffect } from 'react'
import AuthLayout from '../../../../../layout/AuthLayout'
import { Box, Flex, Text, Group, TextInput, Grid, Card, Image, Pagination, NumberFormatter, Modal } from '@mantine/core'
import classes from '../../../../../assets/module-css/AdminLayout.module.css'
import { useDispatch } from 'react-redux'
import { updateRoute } from '../../../../../store/dataRoute'
import { useParams } from 'react-router-dom'
import { useDebouncedCallback } from '@mantine/hooks'
import { getAllProductsList } from '../../../../../services/products'
import LoadingData from '../../../../ui/LoadingData'
import NoData from '../../../../ui/NoData'
import FormDetailProductCatalog from './FormDetailProductCatalog'

const defaultParams = {
  'page[num]': 1,
  'page[limit]': 15,
  'filter[title][like]': ''
}

const FormAddProductCatalog = () => {
  const dispatch = useDispatch()
  const params = useParams()
  const orderId = params.order_id
  const [loadingProduct, setLoadingProduct] = useState(true)
  const [openModalProduct, setOpenModalProduct] = useState(false)
  const [productsList, setProductsList] = useState([])
  const [totalData, setTotalData] = useState(0)
  const [paramsProduct, setParamsProduct] = useState(defaultParams)
  const [detailData, setDetailData] = useState(null)

  const mappingRoute = [
    {
      label: '/',
      route: null
    },
    {
      label: 'Order',
      route: '/order/all'
    },
    {
      label: orderId,
      route: `/order/${orderId}`
    },
    {
      label: 'Add From Catalog',
      route: null
    },
  ]

  const handleGetAllProduct = useDebouncedCallback(async () => {
    setLoadingProduct(true)
    try {
      const response = await getAllProductsList(paramsProduct)
      if (response.success) {
        const dataProduct = response.data
        const countData = response.meta.pagination.total

        setProductsList(dataProduct)
        setTotalData(countData)
      } else {
        setProductsList([])
        setTotalData(0)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingProduct(false)
    }
  }, 500)

  useEffect(() => {
    dispatch(updateRoute({ 'data': mappingRoute }))
    // eslint-disable-next-line
  }, [dispatch])

  useEffect(() => {
    handleGetAllProduct()
    // eslint-disable-next-line
  }, [paramsProduct])

  const handleChangeFilter = (name, val) => {
    setParamsProduct((oldVal) => ({ ...oldVal, [name]: val}))
  }

  const handleChangePage = (val) => {
    // eslint-disable-next-line
    setParamsProduct((oldVal) => ({ ...oldVal, ['page[num]']: val }))
  }

  const handleOpenDetail = (dataProduct) => {
    setOpenModalProduct(true)
    setDetailData(dataProduct.attributes)
  }

  const handleCloseDetail = () => {
    setOpenModalProduct(false)
    setDetailData(null)
  }

  const dataProductList = (data) => {
    const mappingData = data.map((val, index) => {
      return (
        <Grid.Col span={{ base: 3, md: 3, lg: 3, xl: 3 }}>
          <Card shadow="sm" padding="md" radius="md" withBorder onClick={() => handleOpenDetail(val)} style={{ cursor: 'pointer' }}>
            <Card.Section withBorder>
              <Image src={val.attributes.image} height={200} fit='cover' />
            </Card.Section>
            <Box pt={14}>
              <Box mb={10}>
                <Text fz={12} fw={500} lineClamp={2} h={40}>{val.attributes.title}</Text>
                <Text fz={14} fw='bold' my={6}><NumberFormatter prefix={`(${val.attributes.original_currency}) `} thousandSeparator="," decimalSeparator="." fixedDecimalScale={true} value={val.attributes.regular_price} /></Text>
              </Box>
              <Box>
                <Text fz={10} c='dimmed'>Stock: <NumberFormatter suffix={` ${val.attributes.quantity_unit}`} thousandSeparator="," decimalSeparator="." value={val.attributes.quantity} /></Text>
                <Text fz={10} c='dimmed'>Minimum Quantity: <NumberFormatter suffix={` ${val.attributes.quantity_unit}`} thousandSeparator="," decimalSeparator="." value={val.attributes.minimum_qty} /></Text>
              </Box>
            </Box>
          </Card>
        </Grid.Col>
      )
    })
    return mappingData
  }

  return (
    <AuthLayout>
      <Box my={20}>
        <Box>
          <Flex justify='space-between' align="center" mb={30}>
            <Text className={classes.titleLayout}>Products Catalog</Text>
            <TextInput
              value={params['filter[title][like]']}
              placeholder='Search by title'
              onChange={(val) => {
                handleChangeFilter('filter[title][like]', val.target.value)
                handleChangePage(1)
              }}
              size='xs'
            />
          </Flex>
        </Box>
        <Box my={30}>
          <Group mb={10} gap='xs'>
            <Text fz={12}>Total Data Found: </Text>
            <Text fz={12} fw='bold'>{totalData} Products </Text>
          </Group>
          {loadingProduct ? <LoadingData /> : productsList.length > 0 ? <Grid align='center' overflow='hidden' columns={15}>{dataProductList(productsList)}</Grid> : <NoData />}
        </Box>
        <Flex justify='end'>
          <Pagination size='sm' onChange={handleChangePage} total={Math.ceil(totalData / paramsProduct['page[limit]']) || 0} />
        </Flex>
      </Box>
      <Modal opened={openModalProduct} onClose={handleCloseDetail} centered closeOnClickOutside={false} size='80%' title={<Text fw='Bold'>Detail Product</Text>} withCloseButton={false}>
        <FormDetailProductCatalog recentDataProduct={detailData} onCloseModal={handleCloseDetail} reloadList={handleGetAllProduct} />
      </Modal>
    </AuthLayout>
    
  )
}

export default FormAddProductCatalog